const EMPTY_PERCENT_PLACEHOLDER = '—';

/**
 * Renders an ACRIS percent-transfer value, or a dash when the source has none.
 */
function AcrisPercentTransfer(props) {
	const { text } = props;

	if (text === null || text === undefined || text === '') {
		return <span className="acris-percent-empty">{EMPTY_PERCENT_PLACEHOLDER}</span>;
	}

	const amount = Number(text);
	if (!Number.isFinite(amount)) {
		return <span>{text}</span>;
	}

	return <span>{amount}%</span>;
}

export default AcrisPercentTransfer;
